export default __webpack_public_path__ + "static/safe-place-60aa0cdaf0e3942c10484a5e494567a4.mp4";